/** World map top/bottom menu v2 art on Vercel Blob (replaces `public/images/wold_map/`). */
export const WORLD_MAP_MENU_V2_VERCEL_ASSETS_BASE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Redesign/world_map/'

export function worldMapMenuV2VercelAsset(filename: string): string {
  return `${WORLD_MAP_MENU_V2_VERCEL_ASSETS_BASE}${filename}`
}

/**
 * Every webp consumed by the V2 top + bottom menus (full and compact layouts).
 * Spread into the global Vercel preload list so the bars don't pop in on first
 * world-map mount. Keep in sync with `worldMapTopMenuV2Layout.ts` / `worldMapBottomMenuV2Layout.ts`.
 */
export const WORLD_MAP_MENU_V2_PRELOAD_URLS: readonly string[] = [
  // Top bar
  worldMapMenuV2VercelAsset('header.webp'),
  // Bottom bar — full (desktop / tablet)
  worldMapMenuV2VercelAsset('footer.webp'),
  worldMapMenuV2VercelAsset('btn_alliance.webp'),
  worldMapMenuV2VercelAsset('btn_espionage.webp'),
  worldMapMenuV2VercelAsset('btn_enter.webp'),
  worldMapMenuV2VercelAsset('btn_diplomacy.webp'),
  worldMapMenuV2VercelAsset('btn_characters.webp'),
  // Bottom bar — compact (mobile / landscape-compact)
  worldMapMenuV2VercelAsset('ico_kingdom.webp'),
  worldMapMenuV2VercelAsset('ico_alliance.webp'),
  worldMapMenuV2VercelAsset('ico_espionage.webp'),
  worldMapMenuV2VercelAsset('ico_diplomacy.webp'),
  worldMapMenuV2VercelAsset('ico_characters.webp'),
]
